import { ActionIcon, Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconDeviceMobile, IconMail, IconMessageCircle, IconPhone } from "@tabler/icons-react";
import { ReactNode } from "react";
import { useComposeFormCmSelection } from "shared/components/message/compose/useComposeFormCmSelection";
import { Cm } from "src/gql/graphql";

export const CmOverrides = ({ mode }: { mode: "form" | "widget" }) => {
    const { setOptions, selectedCms, isUrgent, hasAny } = useComposeFormCmSelection();

    function toggleCmOptions(cm: Cm[]) {
        const newList = selectedCms.some((it) => cm.includes(it))
            ? selectedCms.filter((it) => !cm.includes(it)).map((it) => ({ method: it }))
            : selectedCms.concat(cm).map((it) => ({ method: it }));
        setOptions(newList);
    }

    const CmOption = ({ label, cms, icon }: { label: string; cms: Cm[]; icon: ReactNode }) => {
        const isSelected = hasAny(cms);

        return (
            <Tooltip label={label}>
                <ActionIcon
                    size="lg"
                    variant={isSelected ? "filled" : "subtle"}
                    onClick={() => !isUrgent && mode != "widget" && !cms.includes(Cm.Email) && toggleCmOptions(cms)}
                    disabled={isUrgent}
                    style={{ cursor: mode == "widget" ? "default" : undefined }}
                    aria-label={`Toggle ${label} method`}
                >
                    {icon}
                </ActionIcon>
            </Tooltip>
        );
    };

    return (
        <Stack>
            <Text fz="sm">Send as:</Text>
            <Group gap="xs">
                <CmOption label="Email (required)" cms={[Cm.Email]} icon={<IconMail />} />
                <CmOption label="Push" cms={[Cm.Ios, Cm.Android]} icon={<IconDeviceMobile />} />
                <CmOption label="Text" cms={[Cm.Sms]} icon={<IconMessageCircle />} />
                <CmOption label="Call" cms={[Cm.Phone]} icon={<IconPhone />} />
            </Group>
        </Stack>
    );
};
